// import axios from 'axios'
// import cookies from '@/mixins/cookies'

import axios from "axios";
import cookie from 'vue-cookies'
import router from '@/router'

export const state = {
    session: {
        token: null,
        sessionId: null,
        sessionLevel: null,
        sessionTimer: null,
        sessionLogin: false,
    },
    identity: null
}

export const actions = {
    checkSession: function (context) {

        let token = null

        if (context.state.session.token != null) {
            token = context.state.session.token;
        } else if (cookie.isKey("token")) {
            token = cookie.get("token")
            context.commit('setToken', token)
        }

        if (token == null) {
            // Create session
            context.dispatch('createSession')
        } else {
            // Check session
            context.dispatch('checkSessionFromServer')
        }

    },
    login: function(context, auth) {
        let url = process.env.VUE_APP_IDENTITY_BACKEND_URL + 'Sessions/CreateAndLogin'
        let data = {
        }
        let options = {
            auth
        }
        axios
            .post(url, data, options)
            .then(response => (
                context.dispatch('handleLogin', response)
            ));
        context.commit("setSessionLogin", true)
    },
    handleLogin: function(context, response) {
        if (response.status === 200) {
            if (response.data.result.authSuccess) {
                context.commit("setSessionLogin", 200)
                context.dispatch('handleSessionData', response.data.result.session)
            } else {
                context.commit("setSessionLogin", 403)
            }
        } else {
            context.commit("setSessionLogin", 500)
        }
    },
    createSession: function (context) {
        let url = process.env.VUE_APP_IDENTITY_BACKEND_URL + 'Sessions/Create'
        let data = {
        }
        axios
            .post(url, data)
            .then(response => (
                context.dispatch('handleSessionResponse', response)
            ));

    },
    checkSessionFromServer: function (context) {
        let url = process.env.VUE_APP_IDENTITY_BACKEND_URL + 'Sessions/Check'
        let data = {
            extend: true
        }
        axios
            .post(url, data)
            .then(response => (
                context.dispatch('handleSessionResponse', response)
            )
            .catch(function () {
                context.dispatch('resetToken')
            }));
    },
    handleSessionResponse: function (context, response) {
        if (response.data.errorCode == null && response.data !== "" && response.data.result !== undefined) {
            let session = response.data.result
            context.dispatch('handleSessionData', session)
        } else {
            context.commit('setSessionLevel', 0)
        }
    },
    handleSessionData: function (context, sessionObject) {
        context.commit('setSessionId', sessionObject.id)
        context.commit('setSessionLevel', sessionObject.level)

        context.commit('setToken', sessionObject.sessionHash)
        cookie.set("token", sessionObject.sessionHash, 60*25)

        context.commit('setIdentity', sessionObject.identity)

        context.dispatch('checkSessionState')

        if (context.state.session.sessionTimer === null) {
            context.state.session.sessionTimer = setInterval(() => (
                context.dispatch('checkSession')
            ), 300000);
        }
    },
    checkSessionState: function (context) {
        if (context.state.session.sessionLevel === null || context.state.session.sessionLevel < 100) {
            //
        } else {
            if (router.currentRoute.name === "Identify") {
                router.push('/')
            }
            if (context.state.session.portfolio === null) {
                context.dispatch('checkPortfolio')
            }
        }
    },
    resetToken: function (context) {
        context.commit('setToken', null)
        context.commit('setSessionLevel', 0)
        cookie.set("token", "", -1)
    },
    logOut: function (context) {
        context.dispatch('resetToken')
        this.sessionTimer = null
        let url = process.env.VUE_APP_OSINKOJA_BACKEND_URL + 'Portfolio/Close'
        let data = {
        }
        axios
            .post(url, data)
            .then(response => (
                context.dispatch('handleLogoutResponse', response)
            )
                .catch(function () {
                    context.dispatch('resetToken')
                    window.location.href='http://www.osinkoja.fi'
                }));
    },
    handleLogoutResponse: function (context) {
        context.dispatch('resetToken')
        window.location.href='http://www.osinkoja.fi'
    },
}

export const mutations = {
    setToken (state, token) {
        state.session.token = token
    },
    setSessionId (state, sessionId) {
        state.session.sessionId = sessionId
    },
    setSessionLevel (state, sessionLevel) {
        state.session.sessionLevel = sessionLevel
    },
    setSessionLogin(state, loginState) {
        state.session.sessionLogin = loginState
    },
    setIdentity(state, identity) {
        state.identity = identity
    }
}

export const getters = {
}

export default {
    state,
    actions,
    mutations,
    getters,
    modules: {
    }
}
